import * as z from "zod";

export const localeLanguagesSchema = z.enum(["sv"]);

export type LocaleLanguages = z.infer<typeof localeLanguagesSchema>;
